import { Button, Card, CardContent, Chip, Collapse, GridLegacy as Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import dayjs from '../utils/dayjs-setup';
import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useParams } from "react-router-dom";
import { DateFormatString, FormatPrice, LogisticoAxiosInstance } from "../utils/constants";
import { ActionTypes, AppContext } from "../store/AppStore";

const HeaderContainer = styled.div`
 background:#016B61;
 color:#FFFFFF;
 height:10vh;
 padding-left:10px;
 display:flex;
 justify-content:center;
 flex-direction:column;
`;

const NotFoundContent = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
text-align:center;
width:100vw;
height:100vh;
`;






export const RutaLogistica = (props)=>{

    const [solicitudData,setSolicitudData] = useState({});
    const [vehiculo,setVehiculo] = useState([]);
    const [conductor,setConductor] = useState({});
    const [ofertas,setOfertas] = useState([]);
    const {token} = useParams(); 
    const {dispatch,store} = useContext( AppContext );
    const [isVisibleModal,setIsVisibleModal] = useState(false);
  
   console.log({token});
    useEffect(()=>{

        if ( token ){
            loadDataInit();
        }

    },[token]);



    const loadDataInit = ()=>{
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
        });
        LogisticoAxiosInstance.get("logistico/obtener-ruta-logistica",{
            headers:{
            Authorization:`Bearer ${token}`
            }
        }).then(({data})=>{
            setSolicitudData(data.value.solicitud);
            setConductor(data.value.conductor);
            setOfertas(data.value.ofertas);
            setVehiculo( data.value.vehiculo );
        }).catch(err=>{

        }).finally(()=>{
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
            });
        });
    }


    if ( !token || Object.keys(solicitudData).length === 0  ){
        return <NotFoundContent>
             <Typography variant="h4" >
                    Ruta de vehículo
            </Typography>
            <Typography variant="h5" >
                    El contenido que estas buscando no se encuentra disponible
            </Typography>
           <div>
           <Button  variant="contained" color="primary"  >Contactar al administrador</Button>
           </div>
        </NotFoundContent>
    }





    return (
        <div>




            <Grid container sx={{marginTop:0}} >

                <Grid item xs={0} sm={0} md={2}  >
                   
               </Grid>
               <Grid item container xs={0} sm={0} md={8} spacing={1}  >

                    <Grid item md={12} >

                        <HeaderContainer>
                            <Typography variant="h4" >
                                Ruta programada - acercate
                            </Typography>

                        </HeaderContainer>
                    </Grid>
              
                  <Grid item md={12} >
                    <Typography variant="h6" >
                            Solicitud de transporte N° {solicitudData.cod}
                        </Typography>
                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="p" >
                        <strong>Vehiculo solicitado:</strong> {vehiculo.placa} - {vehiculo.nombre_tipo}
                        </Typography>
                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="p" >
                        <strong>Fecha de recogida:</strong> {dayjs(solicitudData.fecha).format(DateFormatString)}
                        </Typography>
                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="p" >
                        <strong>Fecha de entrega:</strong> {dayjs(solicitudData.fecha_entrega_destino).format(DateFormatString)}
                        </Typography>
                  </Grid>
                  <Grid item md={12} >
                    <Typography variant="p" >
                        <strong>Conductor:</strong> {conductor.numero_documento} - {conductor.nombres} {conductor.apellidos}
                        </Typography>
                  </Grid>
                  <Grid item md={6} xs={12} sm={12}  >
                     <Chip color="primary" label={`Total kilos a transportar: ${FormatPrice(solicitudData.total_kg)} KG`} ></Chip>
                  </Grid>
                  <Grid item md={6} xs={12} sm={12}  >
                     <Chip color="primary" label={`Total Canastillas a transportar: ${FormatPrice(solicitudData.total_canastillas)} Canastillas`} />
                  </Grid>
                  <Grid item md={12} marginTop={'10px'} >
                    <Typography variant="h6" >
                            Listado de rutas
                        </Typography>
                  </Grid>
                  <Grid item md={12} >

                    <Card>
                        <CardContent>
                           <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Ruta</TableCell>
                                        <TableCell>Origen</TableCell>
                                        <TableCell>Destino</TableCell>
                                        <TableCell>Total Kilos</TableCell>
                                        <TableCell>Total Canastillas</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {solicitudData.route_solicitud?.map( (item,ruta_index)=>[ <TableRow key={item.det_index} >
                                        <TableCell sx={{fontWeight:"600"}}  >{ruta_index+1}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{item.direccion}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{item.municipio_destino}, {item.centro_op} {item.bodega}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{item.total_kg}</TableCell>
                                        <TableCell sx={{fontWeight:"600"}} >{ item.total_canastillas }</TableCell>
                                    </TableRow>,
                                <TableRow>
                                   
                                  <TableCell colSpan={5} >
                                    <Typography variant="p" fontSize='14px' fontWeight={"600"} >
                                        Listado de productos
                                    </Typography>
                                    <Table>
                                        <TableHead>
                                           <TableRow>
                                                <TableCell>Producto</TableCell>
                                                <TableCell>Total unidades</TableCell>
                                                <TableCell>Total kg</TableCell>
                                                <TableCell>Total canastillas</TableCell>
                                           </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                               item.list.map( prod=><TableRow key={prod.cod_detalle_solicitud} >
                                                <TableCell>{prod.nombre_producto}</TableCell>
                                                <TableCell>{prod.total_unidades_tranportar} {prod.un_comprada}</TableCell>
                                                <TableCell>{prod.total_ordenado_kg} Kg</TableCell>
                                                <TableCell>{prod.total_canastillas} Canastillas</TableCell>
                                           </TableRow>)
                                            }
                                        </TableBody>
                                    </Table>
                                    
                                   </TableCell>
                                </TableRow>
                                ] )}
                                </TableBody>
                           </Table>
                        </CardContent>
          
                    </Card>


                  </Grid>
                
                  
                </Grid>

                   <Grid item xs={0} sm={0} md={2}  >
                   
                   </Grid>
             
            </Grid>

        </div>
    )

}